import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { SKIP_AUTH_URLS } from '../tokens/skip-auth-urls.token';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const skipAuthUrls = inject(SKIP_AUTH_URLS);

  // Skip auth headers for configured URLs (e.g., S3 presigned URLs)
  if (skipAuthUrls.some(url => req.url.includes(url))) {
    return next(req);
  }

  if (req.headers.has('X-Skip-Auth')) {
    return next(req.clone({ headers: req.headers.delete('X-Skip-Auth') }));
  }

  const token = authService.tokenResponse();
  
  if (token?.accessToken) {
    authService.updateLastActivity();
    
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token.accessToken}`,
      },
    });
  }

  return next(req);
};
